import { ReactNode, useMemo } from "react";
import { ThemeProvider, createTheme, useTheme } from "@mui/material/styles";

// Phone layouts render under this so every button, input and select defaults to MUI's small size,
// including ones inside shared components and the dialogs they open. Explicit size props still win.
export default function SmallControls({ children }: { children: ReactNode }) {
  const outerTheme = useTheme();
  const theme = useMemo(
    () =>
      createTheme(outerTheme, {
        components: {
          MuiButton: { defaultProps: { size: "small" } },
          MuiIconButton: { defaultProps: { size: "small" } },
          MuiButtonGroup: { defaultProps: { size: "small" } },
          MuiToggleButton: { defaultProps: { size: "small" } },
          MuiTextField: { defaultProps: { size: "small" } },
          MuiFormControl: { defaultProps: { size: "small" } },
          MuiInputBase: { defaultProps: { size: "small" } },
          MuiAutocomplete: { defaultProps: { size: "small" } },
          MuiCheckbox: { defaultProps: { size: "small" } },
          MuiRadio: { defaultProps: { size: "small" } },
          MuiSwitch: { defaultProps: { size: "small" } }
        }
      }),
    [outerTheme]
  );
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
